import React from 'react';
import { Alert as SUIAlert } from '@one-thd/sui-atomic-components';
import styles from './alert.module.scss';

/* TODO: Delete this shared component when Stencil fix bug with border. */
export const Alert = ({ children, ...restProps }: Record<string, unknown>) => {
  return (
    <div className={styles.alertContainer}>
      <SUIAlert {...restProps}>{children}</SUIAlert>
    </div>
  );
};
